/* eslint
    no-empty-function: "warn",
    dot-notation: "off"
*/

import { element, globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import DialogModule from '@webModules/dialog.module';

namespace Meds.Modules {
  @invoke
  export class DisclaimerModule {

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'disclaimerdialog',
          callback: DisclaimerModule.OnClickDisclaimerDialog
        }
      });
    }

    static productDisclaimersAccepted: string[] = [];

    static NeedDisclaimer = async (e: Event): Promise<boolean> => {

      let elem = e.target as HTMLButtonElement;
      if (elem.tagName === 'SPAN') {
        elem = elem.parentNode as HTMLButtonElement;
      }

      const disclaimerDialog = document.querySelector<HTMLDialogElement>(
        `#productdisclaimer-${elem.dataset.productid}`
      );

      const productAtcCode: string | null = elem.dataset.productAtccode;
      DisclaimerModule.productDisclaimersAccepted =
        localStorage.getItem('productDisclaimersAccepted')?.split(',') ?? [];

      const isAccepted =
        DisclaimerModule.productDisclaimersAccepted?.includes(productAtcCode) ??
        false;

      return !(!disclaimerDialog || isAccepted);
    };

    static ShowDisclaimer = async (
      e: Event,
      onAcceptCallback
    ): Promise<string> => {
      // Get the source element
      let elem = e.target as HTMLButtonElement;
      if (elem.tagName === 'SPAN') {
        elem = elem.parentNode as HTMLButtonElement;
      }

      // Find the current dialog.
      const disclaimerDialog = document.querySelector<HTMLDialogElement>(
        `#productdisclaimer-${elem.dataset.productid}`
      );

      await DialogModule.ShowDialog(disclaimerDialog);

      if (disclaimerDialog.returnValue === 'accept') {
        const atcCode: string | null =
          disclaimerDialog.querySelector('form').elements['atc'].value;
        DisclaimerModule.productDisclaimersAccepted.push(atcCode);
        localStorage.setItem(
          'productDisclaimersAccepted',
          DisclaimerModule.productDisclaimersAccepted.toString()
        );
        onAcceptCallback();
      }
      return disclaimerDialog.returnValue;
    };

    static OnClickDisclaimerDialog = async (e: Event) => {
      e.preventDefault();
      e.stopPropagation();

      // Get the source element
      const elem = e.target as HTMLDialogElement;

      if (elem.nodeName === 'DIALOG') {
        elem.close('dismiss');
      }
    };

    static OnCloseDisclaimerDialog = async (e: Event): Promise<string> => {
      e.preventDefault();
      e.stopPropagation();

      // Get the source element
      const elem = e.target as HTMLDialogElement;

      if (elem.returnValue === 'accept') {
        const productDisclaimer: string | null =
          elem.querySelector('form').elements['atc'].value;
        DisclaimerModule.productDisclaimersAccepted.push(productDisclaimer);
        localStorage.setItem(
          'productDisclaimersAccepted',
          DisclaimerModule.productDisclaimersAccepted.toString()
        );
      }
      return elem.returnValue;
    };
  }
}

export default Meds.Modules.DisclaimerModule;
